import React, { useState, useEffect } from 'react';
import { documentAPI } from '../../services/api';
import './documentViewModal.css';

// Preview a document's PDF inline (presigned S3 URL in an iframe) with a download.
const DocumentViewModal = ({ documentId, fileName, onClose }) => {
    const [url, setUrl] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        documentAPI.getDownloadUrl(documentId)
            .then(({ data }) => { if (!cancelled) setUrl(data.downloadUrl); })
            .catch(() => { if (!cancelled) setError('Could not load document.'); });
        return () => { cancelled = true; };
    }, [documentId]);

    const isPdf = /\.pdf$/i.test(fileName || '');

    return (
        <div className="doc-view-overlay" onClick={onClose}>
            <div className="doc-view-modal" onClick={(e) => e.stopPropagation()}>
                <div className="doc-view-header">
                    <h3>{fileName}</h3>
                    <div className="doc-view-header-actions">
                        {url && (
                            <a className="doc-view-download" href={url} target="_blank" rel="noreferrer" download>
                                <i className="fas fa-download" /> Download
                            </a>
                        )}
                        <button className="doc-view-close" onClick={onClose}>&times;</button>
                    </div>
                </div>
                <div className="doc-view-body">
                    {error && <div className="doc-view-error">{error}</div>}
                    {!error && !url && <div className="doc-view-loading">Loading…</div>}
                    {url && isPdf && <iframe title={fileName} src={url} className="doc-view-frame" />}
                    {url && !isPdf && (
                        <div className="doc-view-nonpdf">
                            <i className="fas fa-file" />
                            <p>Preview isn't available for this file type.</p>
                            <a className="doc-view-download" href={url} target="_blank" rel="noreferrer" download>
                                <i className="fas fa-download" /> Download to view
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DocumentViewModal;
